import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Navbar } from "../../commn/Navbar";

export const DisplayUniversity = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get("api/university/get");
        if (Array.isArray(res.data)) {
          setItems(res.data);
        } else {
          console.error("API response is not an array:", res.data);
        }
      } catch (err) {
        console.error("Error fetching universities:", err);
      }
    };

    fetchData();
  }, []);

  const deleteUniversity = async (id) => {
    try {
      await axios.delete(`api/university/delete/${id}`, {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("user")).token,
        },
      });
      alert("Deleted University");
      setItems(items.filter((item) => item._id !== id));
    } catch (err) {
      console.error("Error deleting university:", err);
    }
  };

  const isAdmin = JSON.parse(localStorage.getItem("user")).isAdmin; // Check if the user is an admin

  return (
    <div>
      <Navbar />
      <div className="mt-5" style={{ textAlign: "center" }}>
        {isAdmin && (
          <div className="" style={{ textAlign: "center" }}>
            <Link to={"/universityadd"}>
              <button type="button" className="btn btn-primary mt-5">
                ADD New University
              </button>
            </Link>
          </div>
        )}
        <div className="mt-5">
          <h3>University Partnership</h3>
          <table
            className="table shadow"
            style={{ width: "60%", marginLeft: "15%", marginRight: "15%" }}
          >
            <thead>
              <tr>
                <th scope="col">Image</th>
                <th scope="col">Name</th>
                {isAdmin && <th scope="col">URL</th>}{" "}
                {/* Only show URL for admin */}
                {isAdmin && <th scope="col"></th>}
                {isAdmin && <th scope="col"></th>}
              </tr>
            </thead>
            <tbody>
              {items.length > 0 ? (
                items.map((university) => (
                  <tr key={university._id}>
                    <td>
                      <img
                        className="rounded"
                        style={{ width: "40%", height: "40%" }}
                        src={"/university/" + university.image}
                        alt={university.name}
                      />
                    </td>
                    <td>
                      <a
                        href={university.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {university.name}
                      </a>
                    </td>
                    {isAdmin && <td>{university.url}</td>}{" "}
                    {/* Only show URL for admin */}
                    {isAdmin && (
                      <>
                        <td>
                          <Link to={`/updateuniversity/${university._id}`}>
                            <button className="btn">Update</button>
                          </Link>
                        </td>
                        <td>
                          <button
                            className="btn"
                            onClick={() => deleteUniversity(university._id)}
                          >
                            Delete
                          </button>
                        </td>
                      </>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={isAdmin ? "5" : "3"}>No universities found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
